export enum UserStatusEnum {
  REGISTERED = 1,
  ENROLLED = 2,
  PENDING = 3,
  FINALIZED = 4
}
